





















import { Component, Vue, Prop } from 'vue-property-decorator';
import SingleSelect from './single-select.vue';
import SingleInput from './single-input.vue';
import MultiInput from './multi-input.vue';
import MultiQuestion from './multi-question.vue';
import MultiCheckbox from './multi-checkbox.vue';
import { Question } from '@/domains/template';
import { Record } from '@/domains/work';

@Component({
  name: 'TemplateFormQuestion',
  components: {
    'single-select': SingleSelect,
    'single-input': SingleInput,
    'multi-input': MultiInput,
    'multi-question': MultiQuestion,
    'multi-checkbox': MultiCheckbox,
  },
})
export default class TemplateFormQuestion extends Vue {
  @Prop()
  private value: Question[];

  @Prop({ default: false })
  private save: boolean;

  @Prop()
  private record: Record;

  @Prop()
  private id: number | string;

  get questions(): Question[] {
    return this.value;
  }

  set questions(value: Question[]) {
    this.$emit('input', value);
  }
}
